import { useState } from 'react';
import { CONSTANTS } from '../../../constants/constants';
import Logo from '../../../components/widgets/Logo';
import AppstoreBanner from '../../login/components/login/AppstoreBanner';

const VisitorMessagePanelMobile = () => {
  const [shown, setShown] = useState(false);

  const getStarted = () => {
    setShown(true);
  };

  return (
    <>
      {!shown && (
        <div className="browser-signin-messaging mobile">
          <AppstoreBanner />
          <div
            style={{
              background: `
                linear-gradient(to  right, #08419900 , #08419911, #08419999, #084199aa, #084199dd),
        url(${CONSTANTS.heroImage})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top center',
              backgroundSize: 'cover',
              padding: 20,
              height: '100vh',
              boxSizing: 'border-box',
              backgroundPositionX: '67%'
            }}
          >
            <div style={{ marginTop: -32, paddingBottom: 28 }}>
              <Logo />
            </div>
            <div className="super" style={{ fontSize: 'x-large' }}>
              Welcome to the Era of
            </div>
            <div
              className="headline"
              style={{ fontSize: 44, lineHeight: '38px' }}
            >
              Screenless
              <br />
              Productivity
            </div>
            <div
              className="sub"
              style={{ fontSize: 24, marginTop: '1%', width: '63%' }}
            >
              Convert any document to audio and be productive anywhere
            </div>
            <div
              className="processes"
              style={{
                width: '45%',
                bottom: '24%',
                background: '#33333320',
                marginLeft: -3,
                padding: 0
              }}
            >
              <i
                className="fa fa-chevron-right brandColor24"
                style={{ marginRight: 12, marginLeft: 4, marginBottom: 6 }}
              />
              LISTEN
              <br />
              <i
                className="fa fa-chevron-right brandColor24"
                style={{ marginRight: 12, marginLeft: 4, marginBottom: 6 }}
              />
              HIGHLIGHT
              <br />
              <i
                className="fa fa-chevron-right brandColor24"
                style={{ marginRight: 12, marginLeft: 4, marginBottom: 6 }}
              />
              COMMENT
              <br />
              <i
                className="fa fa-chevron-right brandColor24"
                style={{ marginRight: 12, marginLeft: 4 }}
              />
              COLLABORATE
            </div>
            <div
              style={{
                position: 'absolute',
                width: '85%',
                textAlign: 'center',
                bottom: '12%'
              }}
            >
              <div className="form-group">
                <button
                  class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
                  style={{ maxWidth: 200, height: 42 }}
                  onClick={getStarted}
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VisitorMessagePanelMobile;
